import { useEffect, useState } from 'react'

export const useServiceWorker = () => {
  const [swRegistration, setSwRegistration] = useState<ServiceWorkerRegistration | null>(null)

  useEffect(() => {
    if ('serviceWorker' in navigator) {
      ;(async function () {
        await registerServiceWorker()
      })()
    }
  }, [])

  const registerServiceWorker = async () => {
    await navigator.serviceWorker.register('/sw.js', {
      scope: '/',
      updateViaCache: 'none',
    })
    const registration = await navigator.serviceWorker.ready
    setSwRegistration(registration)
  }

  return {
    swRegistration,
  }
}
